var _mask, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticleInsightBearishDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "article_insight_bearish_disabled_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 0H0v12l8 4 8-4V0z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2E2E",
    fillRule: "evenodd",
    d: "M16 0H0v12l8 4 8-4V0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M0 0v-1h-1v1h1zm16 0h1v-1h-1v1zM0 12h-1v.618l.553.276L0 12zm8 4l-.447.894.447.224.447-.224L8 16zm8-4l.447.894.553-.276V12h-1zM0 1h16v-2H0v2zm1 11V0h-2v12h2zm7.447 3.106l-8-4-.894 1.788 8 4 .894-1.788zm7.106-4l-8 4 .894 1.788 8-4-.894-1.788zM15 0v12h2V0h-2z",
    mask: "url(#article_insight_bearish_disabled_svg__a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#article_insight_bearish_disabled_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7E7E7E",
    d: "M11.375 7.619c-.146-1.02-.503-2.377-1.193-2.934a21.462 21.462 0 00-.04-.26c-.07-.458-.169-1.011-.267-1.306a2.106 2.106 0 00-.134-.32c.351-.673-.415-1.13-.835-.683A2.939 2.939 0 008 1.994a1.823 1.823 0 00-.57.084c-.414-.37-1.096.043-.824.666l.016.032c-.026.05-.048.102-.068.155h-.516a.343.343 0 00-.19.628h.001c-.128.514-.13 1.409.618 1.434a.984.984 0 00.148.188H6.5c-1.309 0-3.176 2.423-1.144 3.18a1.843 1.843 0 00-.153.6 2.89 2.89 0 00-.012.19 1.312 1.312 0 00-.285-.032h-.375A1.312 1.312 0 003.22 10.43v.375a1.312 1.312 0 001.31 1.315h5.344c2.25 0 1.688-3.188 1.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E7E7E",
    d: "M9.1 2.32a.264.264 0 01.202-.101.248.248 0 01.23.149c.036.09.016.205-.056.33L9.1 2.32zm-5.319 8.298a.281.281 0 100-.562.281.281 0 000 .563zm.75-.562a.281.281 0 100-.562.281.281 0 000 .562zm.75.562a.281.281 0 100-.562.281.281 0 000 .563zm-.75 1.125c.26 0 .469-.251.469-.562 0-.31-.21-.563-.469-.563s-.468.252-.468.563c0 .31.21.563.468.563zm2.532-1.125a.281.281 0 100-.562.281.281 0 000 .563zm.75-.562a.281.281 0 100-.562.281.281 0 000 .562zm.75.562a.281.281 0 100-.562.281.281 0 000 .563zm-.75 1.125c.258 0 .468-.251.468-.562 0-.31-.21-.563-.469-.563-.258 0-.468.252-.468.563 0 .31.21.563.468.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M10.57 8.799l.672-.673a.187.187 0 000-.265l-1.234-1.235a.188.188 0 00-.266 0L7.835 8.533a.562.562 0 01-.795 0L2.883 4.376a.187.187 0 010-.265l.672-.672a.187.187 0 01.265 0l3.485 3.485a.187.187 0 00.265 0l1.907-1.908a.562.562 0 01.796 0l1.907 1.908a.187.187 0 00.265 0l.672-.673a.187.187 0 01.32.133V8.93a.188.188 0 01-.187.188h-2.547a.187.187 0 01-.133-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E3E3E",
    d: "M6.75 3.54l-.009.007-.147-.147a.133.133 0 10-.188.187l.121.121-.002.001a.375.375 0 01-.433.012l-.244-.162a.343.343 0 01.19-.628h.51a.338.338 0 01.202.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E7E7E",
    d: "M5.375 8.369c2.063.75 2.063-2.25 0-1.313V8.37zm4.506-1.797c-.194 0-1.131.11-1.131-.64s-1.5-.75-1.5.562c0 1.5 2.813 1.875 2.813 1.875L9.88 6.572z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E3E3E",
    d: "M9.17 2.382a.173.173 0 01.133-.07.156.156 0 01.142.092c.025.06.007.148-.05.247a.094.094 0 10.163.093c.088-.152.109-.295.06-.412a.343.343 0 00-.467-.17.356.356 0 00-.122.098.094.094 0 10.142.122zm-.982.924a.188.188 0 100-.375.188.188 0 000 .375zm1.34 3.218c.298.135.54-.062.844.06.228.09.322.322.527.453.309.199.587.303.668.647.129.55-1.07 1.027-1.07 1.027l-1.112-.27s-1.246-.255-1.71-.807c-.325-.388-.523-.69-.482-1.183.034-.411.116-.728.482-.953.295-.18.56-.237.89-.123.19.066.294.139.42.289.18.216.197.679.197.679s.207.118.346.181zm-4.724-.087c.336-.088.76.445.76.445s.314-.131.565-.11c.171.014.337.044.483.134a.847.847 0 01.377.547c.057.237-.016.517-.144.725-.142.233-.29.281-.525.368-.389.143-.707.03-1.058-.084-.27-.088-.47-.174-.663-.383a1.177 1.177 0 01-.313-1c.051-.307.216-.563.518-.642z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.526,
    cy: 11.168,
    fill: "#3E3E3E",
    rx: 0.482,
    ry: 0.576
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.844,
    cy: 11.168,
    fill: "#3E3E3E",
    rx: 0.482,
    ry: 0.576
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.494,
    cy: 9.775,
    r: 0.3,
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.813,
    cy: 9.775,
    r: 0.3,
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.762,
    cy: 10.319,
    r: 0.3,
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.081,
    cy: 10.319,
    r: 0.3,
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.262,
    cy: 10.337,
    r: 0.3,
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.581,
    cy: 10.337,
    r: 0.3,
    fill: "#3E3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "article_insight_bearish_disabled_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z",
    transform: "translate(2 1)"
  })))));
}
export default SvgArticleInsightBearishDisabled;